import React from 'react';
import { Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const IOSSwitch = withStyles(switchTheme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: switchTheme.spacing(1),
  },
  mediumRoot: {
    width: 51,
    height: 31,
    padding: 0,
    margin: switchTheme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: switchTheme.palette.common.white,
      '& + $track': {
        backgroundColor: '#1A8282',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#e4eded',
      border: '1px solid #fff',
    },
  },
  mediumSwitchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(22px)',
      color: switchTheme.palette.common.white,
      '& + $mediumTrack': {
        backgroundColor: '#1A8282',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#e4eded',
      border: '1px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  mediumThumb: {
    width: 27,
    height: 27,
  },
  track: {
    borderRadius: 26 / 2,
    border: `0px solid ${switchTheme.palette.grey[400]}`,
    backgroundColor: '#e4eded',
    opacity: 1,
    transition: switchTheme.transitions.create(['background-color', 'border']),
  },
  mediumTrack: {
    borderRadius: 16,
    border: `0px solid ${switchTheme.palette.grey[400]}`,
    backgroundColor: '#e4eded',
    opacity: 1,
    transition: switchTheme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, size = 'small', ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: size === 'small' ? classes.root : classes.mediumRoot,
      switchBase: size === 'small' ? classes.switchBase : classes.mediumSwitchBase,
      thumb: size === 'small' ? classes.thumb : classes.mediumThumb,
      track: size === 'small' ? classes.track : classes.mediumTrack,
      checked: classes.checked,
    }}
    {...props}
  />
));

IOSSwitch.propTypes = {};

export default IOSSwitch;
